// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditProfile_formGroup__VXunA {
  margin-top: 5%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  width: 45%;
}

.EditProfile_Label__HivqB {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #828d9a;
  margin-bottom: 2%;
}

.EditProfile_inputField__hyeOc {
  height: 30px;
  padding: 8px 16px;
  border-radius: 8px;
  gap: 8px;
  border: 1px solid #d8dbdf;
  box-shadow: 4px 4px 64px 0px #5f6d7e1a;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #5f6d7e;
}

.EditProfile_inputField__hyeOc::placeholder {
  font-family: "Inter";
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
}

.EditProfile_inputField__hyeOc:focus {
  border: 1px solid #cb9c2d !important;
  outline: none !important;
}

.EditProfile_customRadio__XPVxB {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid #ccc;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  vertical-align: middle;
}

.EditProfile_customRadio__XPVxB:checked {
  background-color: #cb9c2d;
}

.EditProfile_customRadio__XPVxB:checked::before {
  content: "✔";
  display: block;
  text-align: center;
  border: 1px solid #e2e2e2;
  font-weight: bold;
  font-size: 14px;
  color: white;
}

.EditProfile_card__HOfdP {
  width: 45%;
  border: 1px solid #d1d9e2;
  border-radius: 4px;
  box-shadow: 0px 1px 2px 0px #1018280a;
}

.EditProfile_titleRow__LuYmJ {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #5f6d7ec7;
  background-color: #f8f9fb;
  padding: 15px;
}

.EditProfile_row__f8L2e {
  display: flex;
  justify-content: space-around;
  background-color: #f8f9fb;
  padding: 15px;
  border-bottom: 1px solid #d1d9e2;
}

.EditProfile_textLeft__hmcgN,
.EditProfile_customLabelLeft__eCvF9 {
  flex: 1 1;
  text-align: left;
}

.EditProfile_textRight__6YpZf,
.EditProfile_customLabelRight__y1vA9 {
  flex: 1 1;
}

.EditProfile_rowTwo__vBab9 {
  display: flex;
  background-color: white;
  padding: 15px;
  align-items: center;
  justify-content: baseline;
  gap: 45%;
}

.EditProfile_textLeft__hmcgN,
.EditProfile_textRight__6YpZf {
  font-family: "Inter";
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: -0.001em;
  color: #818c99;
}

.EditProfile_containerBio__TzVgj {
  margin-top: 5%;
}

.EditProfile_textarea__odUay {
  width: 50%;
  height: 250px;
  padding: 15px 16px;
  border-radius: 8px;
  border: 1px solid #d8dbdf;
  gap: 8px;
  background: #ffffff;
  background-origin: border-box;
  background-clip: content-box, border-box;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #5f6d7e;
}
.EditProfile_textarea__odUay:focus {
  border: 1px solid #cb9c2d !important;
  outline: none !important;
}

.EditProfile_containerTherapy__m-w5E {
  margin-top: 5%;
}

.EditProfile_terapijaTitle__B13da {
  font-family: "Inter";
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4e4e;
}

.EditProfile_buttonContainer__CxTPG {
  bottom: 0;
  width: 80%;
  display: flex;
  justify-content: center;
  padding: 10px;
  gap: 20px;
  position: fixed;
}
.EditProfile_cancelButton__eaJDh {
  width: 212px;
  height: 52px;
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  gap: 8px;
  background: #ebebeb;
  font-family: "Inter";
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
  border: none;
  color: #808080;
  cursor: pointer;
}
.EditProfile_nextButton__bs8gv {
  width: 212px;
  height: 52px;
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  gap: 8px;
  background: #cb9c2d;
  font-family: "Inter";
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
  border: none;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.EditProfile_cancelButton__eaJDh:hover,
.EditProfile_nextButton__bs8gv:hover {
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/terapeuti/TerapeutProfil/EditProfile.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,sCAAsC;EACtC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,aAAa;EACb,gCAAgC;AAClC;;AAEA;;EAEE,SAAO;EACP,gBAAgB;AAClB;;AAEA;;EAEE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,mBAAmB;EACnB,6BAA6B;EAC7B,wCAAwC;EACxC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;AACd","sourcesContent":[".formGroup {\n  margin-top: 5%;\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  width: 45%;\n}\n\n.Label {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #828d9a;\n  margin-bottom: 2%;\n}\n\n.inputField {\n  height: 30px;\n  padding: 8px 16px;\n  border-radius: 8px;\n  gap: 8px;\n  border: 1px solid #d8dbdf;\n  box-shadow: 4px 4px 64px 0px #5f6d7e1a;\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #5f6d7e;\n}\n\n.inputField::placeholder {\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n}\n\n.inputField:focus {\n  border: 1px solid #cb9c2d !important;\n  outline: none !important;\n}\n\n.customRadio {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  width: 20px;\n  height: 20px;\n  border: 2px solid #ccc;\n  border-radius: 4px;\n  outline: none;\n  cursor: pointer;\n  vertical-align: middle;\n}\n\n.customRadio:checked {\n  background-color: #cb9c2d;\n}\n\n.customRadio:checked::before {\n  content: \"✔\";\n  display: block;\n  text-align: center;\n  border: 1px solid #e2e2e2;\n  font-weight: bold;\n  font-size: 14px;\n  color: white;\n}\n\n.card {\n  width: 45%;\n  border: 1px solid #d1d9e2;\n  border-radius: 4px;\n  box-shadow: 0px 1px 2px 0px #1018280a;\n}\n\n.titleRow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #5f6d7ec7;\n  background-color: #f8f9fb;\n  padding: 15px;\n}\n\n.row {\n  display: flex;\n  justify-content: space-around;\n  background-color: #f8f9fb;\n  padding: 15px;\n  border-bottom: 1px solid #d1d9e2;\n}\n\n.textLeft,\n.customLabelLeft {\n  flex: 1;\n  text-align: left;\n}\n\n.textRight,\n.customLabelRight {\n  flex: 1;\n}\n\n.rowTwo {\n  display: flex;\n  background-color: white;\n  padding: 15px;\n  align-items: center;\n  justify-content: baseline;\n  gap: 45%;\n}\n\n.textLeft,\n.textRight {\n  font-family: \"Inter\";\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 17px;\n  letter-spacing: -0.001em;\n  color: #818c99;\n}\n\n.containerBio {\n  margin-top: 5%;\n}\n\n.textarea {\n  width: 50%;\n  height: 250px;\n  padding: 15px 16px;\n  border-radius: 8px;\n  border: 1px solid #d8dbdf;\n  gap: 8px;\n  background: #ffffff;\n  background-origin: border-box;\n  background-clip: content-box, border-box;\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #5f6d7e;\n}\n.textarea:focus {\n  border: 1px solid #cb9c2d !important;\n  outline: none !important;\n}\n\n.containerTherapy {\n  margin-top: 5%;\n}\n\n.terapijaTitle {\n  font-family: \"Inter\";\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4e4e;\n}\n\n.buttonContainer {\n  bottom: 0;\n  width: 80%;\n  display: flex;\n  justify-content: center;\n  padding: 10px;\n  gap: 20px;\n  position: fixed;\n}\n.cancelButton {\n  width: 212px;\n  height: 52px;\n  padding: 8px 16px 8px 16px;\n  border-radius: 4px;\n  gap: 8px;\n  background: #ebebeb;\n  font-family: \"Inter\";\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  border: none;\n  color: #808080;\n  cursor: pointer;\n}\n.nextButton {\n  width: 212px;\n  height: 52px;\n  padding: 8px 16px 8px 16px;\n  border-radius: 4px;\n  gap: 8px;\n  background: #cb9c2d;\n  font-family: \"Inter\";\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  border: none;\n  color: #ffffff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cancelButton:hover,\n.nextButton:hover {\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formGroup": `EditProfile_formGroup__VXunA`,
	"Label": `EditProfile_Label__HivqB`,
	"inputField": `EditProfile_inputField__hyeOc`,
	"customRadio": `EditProfile_customRadio__XPVxB`,
	"card": `EditProfile_card__HOfdP`,
	"titleRow": `EditProfile_titleRow__LuYmJ`,
	"row": `EditProfile_row__f8L2e`,
	"textLeft": `EditProfile_textLeft__hmcgN`,
	"customLabelLeft": `EditProfile_customLabelLeft__eCvF9`,
	"textRight": `EditProfile_textRight__6YpZf`,
	"customLabelRight": `EditProfile_customLabelRight__y1vA9`,
	"rowTwo": `EditProfile_rowTwo__vBab9`,
	"containerBio": `EditProfile_containerBio__TzVgj`,
	"textarea": `EditProfile_textarea__odUay`,
	"containerTherapy": `EditProfile_containerTherapy__m-w5E`,
	"terapijaTitle": `EditProfile_terapijaTitle__B13da`,
	"buttonContainer": `EditProfile_buttonContainer__CxTPG`,
	"cancelButton": `EditProfile_cancelButton__eaJDh`,
	"nextButton": `EditProfile_nextButton__bs8gv`
};
export default ___CSS_LOADER_EXPORT___;
